import React, { lazy, Suspense, useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import MainCalculatorsList from "./MainCalculators";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";

const TITLE = "Calculatrice en ligne";
const DESCRIPTION = "Utilisez la calculatrice simple en ligne pour effectuer des opérations arithmétiques de base comme l'addition, la soustraction, la multiplication et la division facilement, sans télécharger d'application. Obtenez des résultats précis et rapides depuis n'importe quel appareil.";
const KEYWORDS = "calculatrice simple, calculatrice en ligne, calculs de base, calculatrice gratuite, opérations arithmétiques, outils de calcul en ligne";
const OG_URL = "https://do-calculate.com/fr/calculators/";

const MathCalculator = lazy(() => import("./NormalCalculator"));
const ScientificCalculator = lazy(() => import("./ScientificCalculator"));

function Calculators() {
  const [activeTab, setActiveTab] = useState('scientific');

  const tabContainerStyle = {
    display: 'flex',
    gap: '8px',
    marginBottom: '0',
    padding: '8px',
    background: '#f8f9fa',
    borderRadius: '12px 12px 0 0'
  };

  const getTabButtonStyle = (isActive) => ({
    flex: 1,
    padding: '14px 20px',
    cursor: 'pointer',
    border: '2px solid transparent',
    background: isActive
      ? 'linear-gradient(135deg, #1a5f3f 0%, #2d8a5f 100%)'
      : '#ffffff',
    color: isActive ? '#ffffff' : '#1a5f3f',
    textAlign: 'center',
    fontWeight: isActive ? '700' : '600',
    borderRadius: '10px',
    margin: '0',
    transition: 'all 0.3s ease',
    boxShadow: isActive
      ? '0 4px 12px rgba(26, 95, 63, 0.25)'
      : '0 2px 6px rgba(0, 0, 0, 0.08)',
    transform: isActive ? 'translateY(-2px)' : 'translateY(0)',
  });

  const tabContentStyle = {
    padding: '20px',
    background: '#ffffff',
    borderRadius: '0 0 12px 12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <p>
            Bienvenue sur notre site de calculatrice en ligne ! Nous vous proposons des outils de calcul conçus pour répondre à vos différents besoins en matière d'opérations mathématiques. Que vous ayez besoin d'effectuer des calculs simples ou complexes, nous avons la solution idéale pour vous.
          </p>
          <p>
            Avec la calculatrice ordinaire, vous pouvez facilement effectuer les opérations arithmétiques quotidiennes comme l'addition, la soustraction, la multiplication et la division, ce qui en fait un outil idéal pour une utilisation quotidienne. Si vous avez besoin d'outils de calcul plus avancés, la calculatrice scientifique vous offre des fonctions avancées comprenant les calculs trigonométriques, les logarithmes, les pourcentages, et bien d'autres opérations complexes. Tout cela est disponible en ligne, sans télécharger d'application, vous garantissant un accès facile à tout moment et depuis n'importe où.
          </p>
          <p>
            Profitez d'une expérience de calcul fluide et précise avec nos outils gratuits et directs, et commencez à effectuer vos calculs dès aujourd'hui avec efficacité et rapidité !
          </p>
          <MobileUnderCalAds />
          <div className="border border-light" style={{ borderRadius: '12px', overflow: 'hidden' }}>
            <div className="row">
              <div style={tabContainerStyle}>
                <button
                  style={getTabButtonStyle(activeTab === 'scientific')}
                  onClick={() => setActiveTab('scientific')}
                  onMouseEnter={(e) => {
                    if (activeTab !== 'scientific') {
                      e.target.style.background = '#f0f7f4';
                      e.target.style.borderColor = '#1a5f3f';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (activeTab !== 'scientific') {
                      e.target.style.background = '#ffffff';
                      e.target.style.borderColor = 'transparent';
                    }
                  }}
                >
                  <h2 style={{ fontSize: '16px', margin: 0 }}>
                    Calculatrice Scientifique
                  </h2>
                </button>
                <button
                  style={getTabButtonStyle(activeTab === 'normal')}
                  onClick={() => setActiveTab('normal')}
                  onMouseEnter={(e) => {
                    if (activeTab !== 'normal') {
                      e.target.style.background = '#f0f7f4';
                      e.target.style.borderColor = '#1a5f3f';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (activeTab !== 'normal') {
                      e.target.style.background = '#ffffff';
                      e.target.style.borderColor = 'transparent';
                    }
                  }}
                >
                  <h2 style={{ fontSize: '16px', margin: 0 }}>
                    Calculatrice Simple
                  </h2>
                </button>
              </div>
              <div style={tabContentStyle}>
                {activeTab === 'scientific' && (
                  <Suspense fallback={<div style={{ textAlign: 'center', padding: '20px', color: '#1a5f3f' }}>Chargement...</div>}>
                    <ScientificCalculator />
                  </Suspense>
                )}
                {activeTab === 'normal' && (
                  <Suspense fallback={<div style={{ textAlign: 'center', padding: '20px', color: '#1a5f3f' }}>Chargement...</div>}>
                    <MathCalculator />
                  </Suspense>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="col-sm-12 col-md-10">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>La Calculatrice Simple</h3>
            </div>
            <div className="info-section-body">
              <p>
                <strong>La calculatrice simple</strong> est un outil pratique et efficace qui vous permet d'effectuer des opérations arithmétiques de base facilement, sans avoir besoin de télécharger d'application. Vous pouvez l'utiliser à tout moment et depuis n'importe où via Internet, que ce soit depuis un ordinateur ou un smartphone. Cette calculatrice est idéale pour les opérations quotidiennes comme l'addition, la soustraction, la multiplication et la division, ce qui en fait un outil indispensable pour les étudiants et les professionnels qui ont besoin de calculs rapides et précis.
              </p>
              <p>
                <strong>Comment l'utiliser :</strong> Tout ce dont vous avez besoin, c'est d'une connexion Internet et de naviguer sur le site de la calculatrice. Saisissez les chiffres et les opérations à l'aide de la souris si vous êtes sur ordinateur, ou par toucher si vous êtes sur mobile, et vous obtiendrez le résultat immédiatement. Grâce à sa conception simple, la calculatrice ordinaire vous permet d'effectuer des opérations arithmétiques rapidement et sans complication.
              </p>
              <div>
                <strong>Avantages de la calculatrice simple :</strong>
                <ul>
                  <li>Facilité d'utilisation avec une interface simple et directe.</li>
                  <li>Rapidité d'exécution sans nécessité de télécharger d'applications.</li>
                  <li>Précision dans les calculs arithmétiques quotidiens.</li>
                  <li>Entièrement gratuite, la rendant accessible à tous à tout moment.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>La Calculatrice Scientifique</h3>
            </div>
            <div className="info-section-body">
              <p>
                <strong>La calculatrice scientifique</strong> est un outil avancé qui offre une large gamme de fonctionnalités dépassant les calculs de base. Elle vous permet d'effectuer des opérations mathématiques complexes comme le calcul des pourcentages, des fractions, des fonctions exponentielles, des logarithmes, des calculs trigonométriques et statistiques. Cette calculatrice est idéale pour les étudiants des niveaux supérieurs, les ingénieurs et les scientifiques qui ont besoin d'outils de calcul avancés et précis.
              </p>
              <p>
                <strong>Comment l'utiliser :</strong> Vous pouvez accéder à la calculatrice scientifique en ligne, où elle vous offre une interface avancée vous permettant de saisir des équations et d'effectuer des opérations complexes. Saisissez simplement les chiffres et les équations requis à l'aide des outils de la calculatrice dédiés, et vous obtiendrez les résultats avec précision et efficacité.
              </p>
              <div>
                <strong>Avantages de la calculatrice scientifique :</strong>
                <ul>
                  <li>Fonctions avancées pour calculer les pourcentages, les fonctions exponentielles et les logarithmes.</li>
                  <li>Possibilité d'effectuer des calculs trigonométriques et statistiques.</li>
                  <li>Conception avancée permettant d'exécuter facilement des équations complexes.</li>
                  <li>Disponible gratuitement en ligne, vous permettant d'y accéder depuis n'importe quel appareil.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Calculators;
